import * as React from 'react';
import { Row, Col, Input, Button, Alert } from 'antd';
import strings from '../eyeguide-localization/strings.settings';
import '../css/Login.scss';
import service from '../service/apolloclient.service';
import Token from './common/token';
import Utils from './common/utils';

interface IResetPasswordProps {
    match: any;
}

interface IResetPasswordState {
    newPwd: string;
    confirmPwd: string;
    classesWithErr: string;
    classesWithoutErr: string;
    errorUsername: boolean;
    errorExists: boolean;
    errorNew: boolean;
    errorConfirm: boolean;
    isSuccess: boolean;
    errorUnmatched: boolean;
    errorWrongPwd: boolean;
    username: string;
    tokenId: string;
    isNew: boolean;
    isLinkExpired: boolean;
    isLinkUsed: boolean;
}

export default class extends React.Component<IResetPasswordProps, IResetPasswordState> {
    defUsername: string;
    constructor(props: IResetPasswordProps) {
        super(props);
        let decodedToken = Token.decodeToken(this.props.match.params.tokenid);
        console.log('user', decodedToken);
        let isNew = decodedToken.type === 0 ? false : true;
        this.state = {
            newPwd: '',
            confirmPwd: '',
            classesWithErr: 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorUsername: false,
            errorExists: false,
            errorNew: false,
            errorConfirm: false,
            isSuccess: false,
            errorUnmatched: false,
            errorWrongPwd: false,
            username: decodedToken.username,
            tokenId: this.props.match.params.tokenid,
            isNew: isNew,
            isLinkExpired: this.checkLinkValidity(decodedToken, isNew),
            isLinkUsed: false
        };
        this.defUsername = decodedToken.username;
        document.title = strings.formatString(strings.lsCreateAccountTxt, this.state.username).toString();
        console.log('resetPwd token', Token.decodeToken(this.state.tokenId));
    }

    render() {
        return (
            <div className="Login">
                <div className="container">
                    {(this.state.isLinkExpired || this.state.isLinkUsed) ?
                        <div className="linkExpired">
                            <Alert
                                banner={true}
                                message={(!this.state.isLinkExpired && this.state.isLinkUsed)
                                    ? strings.lsLinkUsed : strings.lsLinkExpr}
                                description={(!this.state.isLinkExpired && this.state.isLinkUsed) ?
                                    strings.lsLinkedUsedMessage : this.state.isNew ? 
                                    strings.lsExpiredAccountMsg : strings.lsExpiredLinkMsg}
                                type="error"
                                showIcon={true}
                            />
                        </div> :
                        <div>
                            <Row>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                    <div className="logoContainer">
                                        {!this.state.isSuccess ?
                                            <h2>
                                                {this.state.isNew ? 'Create your account' :
                                                    strings.formatString(
                                                        strings.lsResetPwdHeadingTxt, this.state.username
                                                    )}
                                            </h2> :
                                            <h2>
                                                {strings.lsSuccessTxt}
                                            </h2>
                                        }
                                    </div>
                                </Col>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                            </Row>
                            <Row className="signInTitle">
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                    {!this.state.isSuccess ?
                                        <h3 className="logoContainer">{strings.lsResetPwdInputHeadingTxt}</h3>
                                        :
                                        <h3 className="logoContainer">{strings.lsUpdatePwdSuccessTxt}</h3>
                                    }
                                </Col>
                                <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                            </Row>
                            <div hidden={this.state.isSuccess}>
                                <Row className="labelRow" hidden={!this.state.isNew}>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                        <span> {strings.lsUsernameTxt}
                                            :</span>
                                    </Col>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                </Row>
                                <div className="passwordContainer">
                                <Row hidden={!this.state.isNew}>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                        <Input
                                            value={this.state.username}
                                            onChange={(val) => {
                                                let username = val.target.value.toLowerCase().replace(/\s/g, '');
                                                this.setState({ username });
                                            }}
                                            className={(this.state.errorUsername || this.state.errorExists) ?
                                                this.state.classesWithErr : this.state.classesWithoutErr}
                                            placeholder={strings.lsUsernamePlaceHolderTxt}
                                            autoFocus={true}
                                        />
                                    </Col>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                </Row>
                                <Row className="row" hidden={!this.state.errorExists}>
                                    <Col xs={1} sm={1} md={2} lg={5} xl={3} />
                                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="errorFrame" />
                                    <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                                        <span className="error">
                                            {strings.lsUsrAlreadyExistTxt}
                                        </span>
                                    </Col>
                                    <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                                </Row></div>

                                <div className="passwordContainer">
                                    <Row className="labelRow">
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                        <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                            <span> {strings.lsPasswordTxt}
                                                :</span>
                                        </Col>
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    </Row>
                                    <Row>
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                        <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                            <Input
                                                value={this.state.newPwd}
                                                onChange={(val) => this.setState({ newPwd: val.target.value })}
                                                className={this.state.errorNew ?
                                                    this.state.classesWithErr : this.state.classesWithoutErr}
                                                placeholder={strings.lsPwdPlaceHolderTxt}
                                                type="password"
                                            />
                                        </Col>
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    </Row>
                                </div>
                                <div className="passwordContainer">
                                    <Row className="labelRow">
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                        <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                            <span> {strings.lsConfirmPwd}
                                                :</span>
                                        </Col>
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    </Row>
                                    <Row>
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                        <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                            <Input
                                                value={this.state.confirmPwd}
                                                onChange={(val) => this.setState({ confirmPwd: val.target.value })}
                                                className={this.state.errorConfirm ?
                                                    this.state.classesWithErr : this.state.classesWithoutErr}
                                                type="password"
                                                placeholder={strings.lsConfirmPwd}
                                            />
                                        </Col>
                                        <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    </Row>
                                    {this.state.errorUnmatched ?
                                        <Row className="row">
                                            <Col xs={1} sm={1} md={2} lg={5} xl={3} />
                                            <Col xs={8} sm={8} md={5} lg={3} xl={5} className="errorFrame" />
                                            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                                                <span className="error">
                                                    {strings.lsPwdMismatchTxt}
                                                </span>
                                            </Col>
                                            <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                                        </Row> : ''}
                                </div>
                            </div>
                            <div className="signinContainer">
                                <Row>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                                        <Button
                                            className="signin"
                                            type="primary"
                                            onClick={e => this.changePassword()}
                                        >
                                            {this.state.isSuccess ? strings.lsReturnToLoginTxt :
                                                this.state.isNew ? 'Create your account' :
                                                    strings.lsChangePwdTxt}
                                        </Button>
                                    </Col>
                                    <Col xs={2} sm={4} md={6} lg={8} xl={9} />
                                </Row>
                            </div>
                        </div>}
                </div>
            </div>
        );
    }

    private checkLinkValidity(token: any, isNew: boolean) {
        let linkTime = token.time;
        let currTime = new Date().getTime();
        console.log('linkTime', linkTime);
        if (currTime - linkTime < (isNew ? 2592000000 : 604800000)) {
            return false;
        } else {
            return true;
        }
    }

    /*private checkIfLinkUsed(token: any) {
        let ser = new service();
        let resp: any= await ser.checkIfLinkUsed(token.uid);
        console.log('Response for link used', resp);
        if(resp.status === 0) {
        return true;
        } else if(resp.status === 1 && resp.message.indexOf('Link Used') > -1) {
            return false;
        }
    }*/

    private getChangePwdInput() {
        let input: any = {
            username: this.state.username,
            newPassword: this.state.newPwd
        };
        return input;
    }

    private async changePassword() {
        if (this.state.isSuccess) {
            location.href = '/login';
        } else {
            if (await this.validateInput()) {
                console.log('change password');
                let ser = new service();
                let resp: any = await ser.changePasswordWithToken(
                    this.getChangePwdInput(),
                    this.state.tokenId
                );
                console.log('response for Change password', resp);
                if (resp.status === 0) {
                    document.title = strings.lsSuccessPageTitleTxt;
                    this.setState({
                        isSuccess: true
                    });
                } else if (resp.status === 1 && resp.message.indexOf('password already updated') > -1) {
                    this.setState({
                        isLinkUsed: true
                    });
                }
            } else {
                console.log('false');
            }
        }
    }

    private async validateInput() {
        let isValid: boolean = true;
        let errorNew: boolean = false;
        let errorConfirm: boolean = false;
        let errorUnmatched: boolean = false;
        let errorUsername: boolean = false;
        let errorExists: boolean = false;

        if (this.state.isNew) {
            if (!this.state.username) {
                errorUsername = true;
            } else if (!await this.validateUsername()) {
                errorExists = true;
            }
        }

        if (this.state.newPwd !== null &&
            (this.state.newPwd === undefined || this.state.newPwd.trim() === '')) {

            errorNew = true;
        } else if (!Utils.validatePassword(this.state.newPwd)) {
            errorNew = true;
        } else {
            errorNew = false;
        }

        if (this.state.confirmPwd !== null &&
            (this.state.confirmPwd === undefined || this.state.confirmPwd.trim() === '')) {
            errorConfirm = true;
        } else {
            errorConfirm = false;
        }

        if (!errorConfirm && !errorNew) {
            if (this.state.confirmPwd !== this.state.newPwd) {
                errorUnmatched = true;
            }
        }
        if (errorUsername || errorConfirm || errorNew || errorUnmatched || errorExists) {
            isValid = false;
        }
        this.setState({ errorConfirm, errorNew, errorUnmatched, errorUsername, errorExists });
        return isValid;
    }

    /**
     * Validates the username provided by user while creating user,
     * by calling the server
     */
    private async validateUsername() {
        console.log('username', this.state.username);
        let ser = new service();
        let response: any;
        if (this.state.username === this.defUsername) {
            return true;
            
        } else if (this.state.username !== null && this.state.username !== undefined
                         && this.state.username.length > 0) {
            response = await ser.verifyUsername(this.state.username, this.state.tokenId);
            console.log('response', response);
            if (response.status === 0) { // success
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword.tsx